import { CircularProgress } from "@mui/material";
import { Box, styled } from "@mui/system";

const StyledLoading = styled("div")(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    width: "auto",
    height: "25px",
  },
  "& .circleProgress": {
    position: "absolute",
    left: -7,
    right: 0,
    top: "calc(50% - 25px)",
  },
}));

const Loading = ({ withImage = true }) => {
  return (
    <StyledLoading>
      <Box position="relative">
        {withImage ? (
          <img
            className="loding_image"
            style={{
              position: "absolute",
              left: "4px",
              top: "-18px",
            }}
            src="/assets/images/logo_doorway.png"
            alt=""
          />
        ) : (
          <div />
        )}
        <CircularProgress className="circleProgress" />
      </Box>
    </StyledLoading>
  );
};

export default Loading;
